import React from 'react';
import { useIntl } from 'react-intl';
import { MenuItem, Select } from '@mui/material';
import { CenteredFlexBox } from '../FlexBox';
import { ICON_BY_NAME, resolveIcon } from '../../Utils/constants/icons';

const ICON_NAMES = Object.keys(ICON_BY_NAME);

/**
 * Picks one of the icons addressable by name, showing each with its own glyph.
 *
 * @param {Object} props - Component props.
 * @param {String} props.value - The chosen icon's name.
 * @param {Function} props.onChange - Receives the name, empty for none.
 * @param {String} props.width - How wide the select is.
 *
 * @returns {React.JSX.Element}
 */
const IconSelect = function IconSelect({
  value = '',
  onChange = () => {},
  width = '210px',
}) {
  const intl = useIntl();

  return (
    <Select
      size="small"
      displayEmpty
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      sx={{ width, flex: 'none' }}
      renderValue={(name) => {
        if (!name) return intl.messages.NO_ICON;
        const Icon = resolveIcon(name);

        return (
          <CenteredFlexBox gap="8px">
            <Icon fontSize="small" />
            {name}
          </CenteredFlexBox>
        );
      }}
    >
      <MenuItem value="">{intl.messages.NO_ICON}</MenuItem>
      {ICON_NAMES.map((name) => {
        const Icon = resolveIcon(name);

        return (
          <MenuItem key={name} value={name}>
            <CenteredFlexBox gap="8px">
              <Icon fontSize="small" />
              {name}
            </CenteredFlexBox>
          </MenuItem>
        );
      })}
    </Select>
  );
};

export default IconSelect;
